import { useTranslation } from "react-i18next";

const PlayNoCountDown = () => {

    const { t } = useTranslation();


    return (<div className="play-no-countdown-container">
        {t("noGame").toUpperCase()}
    </div>);
}

export default PlayNoCountDown;